export type AppStatus = {
  currentStatus: Status;
  timeStart: number;
};

export enum Status {
  Mount = 'MOUNTED',
  Unmount = 'NOT_MOUNTED',
}
